import Vue from 'vue';

import TreeMenu from '@/components/TreeMenu';
Vue.component('TreeMenu', TreeMenu);

import Spinner from '@/components/Spinner';
Vue.component('Spinner', Spinner);

import Error from '@/components/Error';
Vue.component('Error', Error);
